import { IEnvironmentConfiguration } from './environment';

export const environmentConfiguration: IEnvironmentConfiguration = {
	apiBasePath: 'https://pilotpay-api.activeaero.com',
	isProduction: true,
	appInsightsKey: '640ed371-5568-40b1-8dbf-304a9d7788e2',
	frontendIdentityUrl: 'https://identity-service-ui.ascentgl.com',
	backendIdentityUrl: 'https://identity-service-api.ascentgl.com',
	allowedEmailDomains: ['ascentgl.net']
};
